// Advertisement.js
import React from 'react';
import './Advertisement.css';

const Advertisement = () => {
    const adOptions = [
        {
            type: 'Banner',
            description: 'Displayed at the top of the page',
            price: '$25 per week',
            imgSrc: 'https://via.placeholder.com/300x150?text=Banner+Ad'
        },
        {
            type: 'Modal',
            description: 'Popup ad displayed to users',
            price: '$30 per week',
            imgSrc: 'https://via.placeholder.com/300x150?text=Modal+Ad'
        },
        {
            type: 'Sidebar',
            description: 'Displayed on the side of the page',
            price: '$30 per week',
            imgSrc: 'https://via.placeholder.com/300x150?text=Sidebar+Ad'
        },
        {
            type: 'Footer',
            description: 'Displayed at the bottom of the page',
            price: '$10 per week',
            imgSrc: 'https://via.placeholder.com/300x150?text=Footer+Ad'
        },
        {
            type: 'Interstitial',
            description: 'Full-page ad displayed between content',
            price: '$50 per week',
            imgSrc: 'https://via.placeholder.com/300x150?text=Interstitial+Ad'
        }
    ];

    return (
        <div className="advertisement-page">
            <h1 className="title">Advertise with Us</h1>
            <p className="description">
                Choose from our advertisement options to promote your brand effectively:
            </p>

            <div className="ad-grid">
                {adOptions.map((ad, index) => (
                    <div key={index} className="ad-card">
                        {/* <img src={ad.imgSrc} alt={`${ad.type} Ad`} className="ad-image" /> */}
                        <div className="ad-details">
                            <h3 className="ad-title">{ad.type} Ad</h3>
                            <p className="ad-description">{ad.description}</p>
                            <div className="ad-price">{ad.price}</div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="submission-section">
                <h2 className="submission-title">Submit Your Advertisement</h2>
                <p className="submission-description">
                    Use the embedded form below to submit your advertisement. We offer a secure and
                    easy payment process.
                </p>

                <iframe
                    id="JotFormIFrame-250022625940044"
                    title="Add Proposal Form"
                    onload="window.parent.scrollTo(0,0)"
                    allowtransparency="true"
                    allow="geolocation; microphone; camera; fullscreen"
                    src="https://form.jotform.com/250022625940044"
                    frameborder="0"
                    style={{
                        minWidth: '100%',
                        maxWidth: '100%',
                        height: '539px',
                        border: 'none'
                    }}
                ></iframe>
            </div>
        </div>
    );
};

export default Advertisement;
